export const ionMap = {
  'H+': 1.007276,
  'NH4+': 18.033825567812,
  'Na+': 22.9892207010905,
  'K+': 38.9631581000905 ,
};
